const reg = /(^[+-]?\d+)(\d{3})/;

export const commify = function (n?: number | string): string {
  if (n === undefined || n === null) {
    return '';
  }

  const strValue: string = n.toString();
  const [integerPart = '', decimalPart] = strValue.split('.');

  let formattedInteger: string = integerPart;

  while (reg.test(formattedInteger)) {
    formattedInteger = formattedInteger.replace(reg, '$1,$2');
  }

  if (!decimalPart) {
    return formattedInteger;
  }

  return `${formattedInteger}.${decimalPart.slice(0, 2)}`;
};
